var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import InfinityTable from "@/components/Infinitytable";
import { LocalStorageKeys } from "@/constants/localStorage";
import { useApi } from "@/hooks/useApi";
import { Card, Tabs } from "@atom/ui-kit";
import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { GameManagement } from "../game-management";
import { columns } from "./TransactionManagement.columns";
import { TransactionTabKeys, TransactionTabs } from "./TransactionManagement.constants";
import TransactionManagementFilterSpace from "./TransactionManagement.filters";
import { fetchTransactions } from "./TransactionManagement.helpers";
import { TransactionContainer } from "./TransactionManagement.style";
//TODO rename tableName prop to tableId
var TransactionManagement = function (_a) {
    var isReusable = _a.isReusable, variant = _a.variant, props = __rest(_a, ["isReusable", "variant"]);
    var t = useTranslation().t;
    var _b = useState(TransactionTabKeys.Round), selectedTab = _b[0], setSelectedTab = _b[1];
    var _c = useState([]), transactions = _c[0], setTransactions = _c[1];
    var _d = useApi({
        asyncFunction: fetchTransactions,
        successCallback: function (response) {
            var _a, _b;
            console.log("API Response:", response);
            var newData = [];
            switch (variant || selectedTab) {
                case TransactionTabKeys.Player:
                    newData = ((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.data) || [];
                    break;
                case TransactionTabKeys.Game:
                case TransactionTabKeys.Table:
                    newData = (response === null || response === void 0 ? void 0 : response.data) || [];
                    break;
                case TransactionTabKeys.Tenant:
                    newData = ((_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.data) || [];
                    break;
            }
            setTransactions(newData);
        },
    }), callTransactionManagementList = _d.call, transactionManagementData = _d.data, transactionManagementLoading = _d.loading;
    var handleSearch = useCallback(function (values, variant) {
        var payload = { tenant: localStorage.getItem(LocalStorageKeys.TENANT) || "wisegaming" };
        switch (variant || selectedTab) {
            case TransactionTabKeys.Player:
                payload = __assign(__assign({}, payload), { userid: values.userId, startTime: values.dateRange[0].unix(), endTime: values.dateRange[1].unix() });
                break;
            case TransactionTabKeys.Game:
                payload = __assign(__assign({}, payload), { gameid: values.gameId, isAsc: true });
                break;
            case TransactionTabKeys.Table:
                payload = __assign(__assign({}, payload), { tableid: values.tableName });
                break;
            case TransactionTabKeys.Tenant:
                payload = __assign({}, payload);
                break;
        }
        callTransactionManagementList(__assign(__assign({}, payload), { selectedTab: variant || selectedTab }));
    }, [selectedTab, callTransactionManagementList]);
    useEffect(function () {
        if (variant) {
            handleSearch(props, variant);
        }
    }, [variant, props.gameId, props.tableName, props.username, handleSearch]);
    var handleTabChange = useCallback(function (value) {
        setTransactions([]);
        setSelectedTab(value);
    }, []);
    return (_jsxs(Card, { style: { padding: "20px 0" }, children: [_jsx(Tabs, { defaultActiveKey: selectedTab, items: TransactionTabs(t), size: "small", onChange: handleTabChange }), selectedTab === TransactionTabKeys.Round && _jsx(GameManagement, { requestType: "gameId" }), _jsxs(TransactionContainer, { children: [_jsx(TransactionManagementFilterSpace, { selectedTab: selectedTab, onSearch: handleSearch }), (transactions === null || transactions === void 0 ? void 0 : transactions.length) > 0 && (_jsx(InfinityTable, { columns: columns(t), dataSource: transactions, loading: transactionManagementLoading, rowClassName: function (record) { return (record.game.winner ? "table-winner-row" : ""); }, rowHoverable: false, rowKey: "id" }))] })] }));
};
export default TransactionManagement;
